import { IZCoreEmailTemplate } from '../types';
import { EntityStatus } from '../refData/EntityStatus';
import { AppGlobals } from '../AppGlobals';
import { EntityService } from './EntityService';

export class ZCoreEmailTemplateService extends EntityService<IZCoreEmailTemplate> {
    //public readonly parentEntities = ['ManagedByL2', 'ManagedByL3'];
    //protected childrenEntities = ['Contributors($expand=ContributorUser)', 'CustomFields($expand=CustomFieldDfn)'];

    constructor() {
        super(`/ZCoreEmailTemplates`);
    }

    // public readAllForLookup(includeClosed?: boolean): Promise<IZCoreEmailTemplate[]> {
    //     return this.readAll(
    //         `?$select=ID,Title`
    //         + `&$orderby=Title&$filter=CustomerID eq ${AppGlobals.CustomerID}`
    //         + (includeClosed ? `` : ` and EntityStatusID eq ${EntityStatus.Open}`)
    //     );
    // }

    public readAllForList(includeClosed?: boolean): Promise<IZCoreEmailTemplate[]> {
        return this.readAll(
            `?$select=ID,Title`
            + `&$orderby=Title`
            + `&$filter=CustomerID eq ${AppGlobals.CustomerID}`
        );
    }


}